import {
    GA_BUTTON_EVENT,
    GA_CLICK_SEASEARCHER_LINK
} from "../../constants/GaEvents";
import { sendGAEvent } from "../../services/AnalyticsService";
import { ScreeningPscInspection } from "../../types/Screening";
import { SeaSearcherLinkButton } from "@idwal/idwal-react-components";

export const ScreeningPscDeficienciesBody = (item: ScreeningPscInspection) => {
    if (item.number_of_deficiencies === 0 || !item.vessel_id) {
        return <p className="text-center">{item.number_of_deficiencies}</p>;
    }

    const gaEvent = () =>
        sendGAEvent(GA_BUTTON_EVENT, GA_CLICK_SEASEARCHER_LINK);

    return (
        <SeaSearcherLinkButton
            vesselId={`${item.vessel_id}`}
            gaEvent={gaEvent}
            route="inspections"
        >
            <p className="screening-psc-deficiencies-text">
                {item.number_of_deficiencies}
            </p>
        </SeaSearcherLinkButton>
    );
};
